import { CircularProgress } from '@material-ui/core';
import MyModal from "components/MyModal";
import { Text } from 'components/Text';
import React, { useState } from 'react';
import ImageUploader from "react-images-upload";
import { toastr } from 'react-redux-toastr';
import FormInfo from './FormInfo';
import InternalDrawer from './InternalDrawer';
import './formInformation.scss';

const FormInformation = ({ ...props }) => {
  const formik = { ...props };
  const [active, setActive] = useState('generalInfo');
  const [openUploadCoverImage, setOpenUploadCoverImage] = useState(false);
  const handleCloseCoverImage = () => {
    setOpenUploadCoverImage(false);
  };

  const handleOpenCoverImage = () => {
    setOpenUploadCoverImage(true);
  }


  const onUploadFile = async (pictureFiles) => {
    const fileSize = pictureFiles[0].size;
    if (fileSize > 5242880) {
      toastr.info("File size should be less than 5MB");
      setOpenUploadCoverImage(false);
      return;
    }

    const img = new Image();
    img.src = URL.createObjectURL(pictureFiles[0]);
    img.onload = () => {
      const width = img.width;
      const height = img.height;
      if (width !== height) {
        toastr.info("Image ratio should be 1:1");
        setOpenUploadCoverImage(false);
      } else if (width < 800 || height < 800) {
        toastr.info("Image size should be more than 800x800");
        setOpenUploadCoverImage(false);
      } else {
        uploadFile(pictureFiles[0]);
      }
    };
  };

  const uploadFile = async (file) => {
    props.setCoverImage(file);
    let imageDataUrl = await readFile(file);
    props.setCroppedImage(imageDataUrl);
    setOpenUploadCoverImage(false);
  }

  function readFile(file) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        resolve(reader.result)
      }, false);
      reader.readAsDataURL(file);
    });
  }

  return (
    <div className="class_info_container">
      <div className="left_section">
        <div className="left_content">
          <div className="info_title">
            <h2>Form Information</h2>
            <p>Please complete the details below</p>
          </div>
          {formik.values?.loading ? (
            <div className="w-100 text-center mt-5">
              <CircularProgress />
            </div>
          ) : (
            <div className="classTap_content">
                <FormInfo formik={formik} 
                  setCoverImage={props.setCoverImage}
                  coverImage={props.coverImage}
                  handleOpenCoverImage={handleOpenCoverImage}
                  croppedImage={props.croppedImage}
                />
            </div>
          )}
        </div>
      </div>
      <div className="right_sectoin">
        <InternalDrawer formik={formik} />
      </div>

      <MyModal open={openUploadCoverImage} onClose={handleCloseCoverImage}>
        <div className="modal-body text-center">
          <Text style={{ fontWeight: "bolder" }}>Upload Cover Image</Text>
        </div>
        <div className="text-center">
          <div className="mt-2">
            <ImageUploader
              withIcon={false}
              withPreview={true}
              buttonText="Choose images"
              onChange={onUploadFile}
              accept=".png,.jpg,.jpeg"
              imgExtension={[".jpg", ".png", ".jpeg"]}
              label="Max file size: 5MB, accepted: jpg, png, jpeg | Min Image Dimension: 800x800"
              maxFileSize={5242880}
            />
          </div>
        </div>
      </MyModal>
    </div>
  );
};

export default FormInformation;
